import moment from 'moment-timezone';

export function toTimeInput(value: moment.Moment | string | null | undefined, tz: string): string {
    if (!value) return '';
    return moment.tz(value, tz).format('HH:mm');
}

export function buildTimeInZone(time: string, dateSource: moment.Moment | string, tz: string): moment.Moment {
    const [hour, minute] = time.split(':').map(Number);
    return moment.tz(dateSource, tz).set({ hour, minute, second: 0, millisecond: 0 });
}
